import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@wearewqa/wqa-design-system";
import { CreateVersionModal } from "../../modals/CreateVersionModal";
import { useAuth } from "../../hooks/auth.provider";

export const AppPageEmptyApp = () => {
  const [showForm, setShowForm] = useState<boolean>(false);
  const { appId } = useParams();
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated && appId && (
        <>
          <Button label="Upload a Version" onClick={() => setShowForm(true)} />
          <CreateVersionModal
            isOpen={showForm}
            onClose={() => setShowForm(false)}
            appId={appId}
          />
        </>
      )}
    </>
  );
};
